import React, { useState } from 'react';
import './ServiceCard.css';
import { getServiceTypeName } from '../constants/serviceTypes';

const ServiceCard = ({ service, onEdit, onDelete, onClick }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    onEdit(service);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    onDelete(service);
  };

  const handleCardClick = () => {
    if (onClick) {
      onClick(service);
    }
  };

  return (
    <div className="card service-card" onClick={handleCardClick}>
      <button className="menu-button" onClick={handleMenuToggle}>
        ⋮
      </button>
      {showMenu && (
        <>
          <div className="menu-overlay" onClick={() => setShowMenu(false)} />
          <div className="menu-dropdown">
            <button className="menu-item" onClick={handleEdit}>
              Редактировать
            </button>
            <button className="menu-item delete" onClick={handleDelete}>
              Удалить
            </button>
          </div>
        </>
      )}
      <div className="service-content">
        <div className="service-type-badge">{getServiceTypeName(service.type)}</div>
        <div className="service-name">{service.name}</div>
        {service.description && (
          <div className="service-description">{service.description}</div>
        )}
        <div className="service-meters">
          {Array.isArray(service.tariffs) && service.tariffs.length > 0 ? (
            <>
              {service.tariffs.length === 1 ? '1 тариф' : 
               service.tariffs.length < 5 ? `${service.tariffs.length} тарифа` : 
               `${service.tariffs.length} тарифов`}
            </>
          ) : (
            'Без тарифов'
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
